// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".templateLayout {\n  min-width: -webkit-max-content;\n  min-width: -moz-max-content;\n  min-width: max-content;\n}\n.templateLayout .flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
